import template from './thankyou.html';
export var ThankyouComponent = {
    template: template,
    controller: /** @class */ (function () {
        function ThankyouComponent(CartService, $state) {
            'ngInject';
            this.cart = null;
            this.errors = {
                havePageErrors: false,
                pageErrors: '',
                pageErrorType: ''
            };
            this.CartService = CartService;
            this.$state = $state;
            this.isAkrisOrder = !!this.$state.params.isAkrisOrder;
        }
        ThankyouComponent.prototype.$onInit = function () {
            if (this.isAkrisOrder) {
                this.cart = Object.assign({}, this.CartService.cartData);
            }
            else {
                if (this.CartService.failedOrderCart) {
                    this.cart = Object.assign({}, this.CartService.failedOrderCart);
                    this.CartService.resetFailedOrderCart();
                }
                else {
                    var result = this.CartService.getOrderResult();
                    this.cart = Object.assign({}, result.salesOrder);
                }
            }
            this.getOrderResultForThankyouPage();
        };
        ThankyouComponent.prototype.getOrderResultForThankyouPage = function () {
            var orderStatus = this.CartService.getOrderResult();
            if (orderStatus) {
                var orderDate = new Date();
                this.orderDate = orderDate.toLocaleDateString();
                this.customerPoNumber = orderStatus.customerPoNumber;
                this.status = orderStatus.status;
            }
        };
        return ThankyouComponent;
    }())
};
//# sourceMappingURL=thankyou.component.js.map